(function () {
  function pad2(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatRemaining(ms) {
    if (ms <= 0) return 'ENDING SOON';
    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    return d + 'd ' + pad2(h) + 'h ' + pad2(m) + 'm ' + pad2(s) + 's';
  }

  document.querySelectorAll('[data-campaign-ticker]').forEach(function (el) {
    var saleStarts = new Date(el.getAttribute('data-sale-starts')).getTime();
    var saleEnds = new Date(el.getAttribute('data-sale-ends')).getTime();
    var nextSaleStarts = new Date(el.getAttribute('data-next-sale-starts')).getTime();
    var hasSaleStart = !isNaN(saleStarts);
    var hasSaleEnd = !isNaN(saleEnds);
    var hasNextStart = !isNaN(nextSaleStarts);
    if (!hasSaleStart && !hasSaleEnd && !hasNextStart) return;

    var liveMode = el.querySelector('[data-ticker-live]');
    var upcomingMode = el.querySelector('[data-ticker-upcoming]');
    var liveOutputs = el.querySelectorAll('[data-countdown-live]');
    var upcomingOutputs = el.querySelectorAll('[data-countdown-upcoming]');

    function tick() {
      var now = Date.now();
      var isLive = hasSaleStart && hasSaleEnd && now >= saleStarts && now < saleEnds;

      if (liveMode) liveMode.style.display = isLive ? 'block' : 'none';
      if (upcomingMode) upcomingMode.style.display = isLive ? 'none' : 'block';

      if (isLive) {
        var text = formatRemaining(saleEnds - now);
        liveOutputs.forEach(function (node) { node.textContent = text; });
      } else if (upcomingOutputs.length) {
        var upcomingText;
        if (hasSaleStart && now < saleStarts) {
          upcomingText = formatRemaining(saleStarts - now);
        } else if (hasNextStart) {
          var untilNext = nextSaleStarts - now;
          upcomingText = untilNext > 0 ? formatRemaining(untilNext) : 'DROPPING SOON';
        } else {
          upcomingText = '--';
        }
        upcomingOutputs.forEach(function (node) { node.textContent = upcomingText; });
      }
    }

    tick();
    setInterval(tick, 1000);
  });
})();